import React from 'react';
import { FormHelperText, FormLabel, Grid, Stack, Typography } from '@mui/material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

/**
 * Whether the broker group has a consented tenant (read only), with a warning when it
 * doesn't, since the backend can't reach its SharePoint.
 */
export const BrokerGroupAdminConsentField = ({ hasTenant }) => (
	<Grid size={12}>
		<Stack direction='row' spacing={3}>
			<FormLabel>{'Admin consent?'}</FormLabel>
			<Typography>{hasTenant ? 'Yes' : 'No'}</Typography>
		</Stack>
		{!hasTenant && (
			<FormHelperText sx={{ color: 'warning.main', ml: 0 }}>
				<Stack direction='row' spacing={1}>
					<WarningAmberOutlinedIcon fontSize='small' color={'warning'} />
					<span>Sharepoint operations will only happen from the frontend</span>
				</Stack>
			</FormHelperText>
		)}
	</Grid>
);
